<template>
    <div class="view-wrapper" v-scroll="scrollParams">
        <ul class="area-wrapper" v-for="areaData in showData" :key="areaData.label">
            <div class="area-name">{{areaData.label}}</div>
            <el-tag
                v-for="item in areaData.children"
                :key="item.id"
                effect="plain"
                :closable="!levelSelect.innerDisabled && !item.disabled"
                @close="handleClose(item)"
            >
                <level-label :data="item" is-view></level-label>
            </el-tag>
        </ul>
        <div class="placeholder" v-if="!data.length">无选择数据</div>
    </div>
</template>
<script>
import {deepClone} from '@lsfe/tools';
import LevelLabel from './OptionsWrapper/LevelLabel';

export default {
    components: {
        LevelLabel
    },
    inject: ['levelSelect'],
    data() {
        return {
            scrollParams: {
                // el: '.option',
                element: null,
                handleScroll: this.handleScroll,
                limit: 20,
                end: 20
            },
            showMore: false
        };
    },
    computed: {
        data() {
            return this.levelSelect.store.getViewData();
        },
        showData() {
            const {end} = this.scrollParams;
            const result = [];
            let modeData;
            // i 记录整体个数  y 记录外部个数
            for (let i = 0, y = 0; y < this.data.length; y++) {
                modeData = this.data[y].children;
                if (i + modeData.length <= this.scrollParams.end) {
                    result.push(this.data[y]);
                    i += modeData.length;
                } else {
                    result.push({
                        ...this.data[y],
                        children: modeData.slice(0, end - i)
                    });
                    return result;
                }
            }
            return result;

        }
    },
    methods: {
        handleScroll(el, position) {
            this.scrollParams.element = el;
            let limmitDistance = 50; // 设置距离边缘的距离
            let scrollTo = el.scrollTop - position < 0 ? 'up' : 'down';
            if (scrollTo === 'down') {
                if (el.scrollTop + el.clientHeight + limmitDistance >= el.scrollHeight) {
                    this.scrollParams.end += this.scrollParams.limit;
                }
            }
        },
        handleClose(item) {
            this.levelSelect.store.handleCheck(false, item, false);
            this.levelSelect.emitChange();
            this.levelSelect.emitCheck(false, deepClone(item));
        },
    }
};
</script>
<style lang="scss" scoped>
.view-wrapper {
    position: relative;
    width: 300px;
    min-height: 200px;
    max-height: 300px;
    overflow: auto;
    .placeholder {
        width: 100px;
        height: 14px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        text-align: center;
    }
    .area-wrapper {
        padding: 0 10px;
        font-size: 13px;
        .area-name {
            font-size: 10px;
            color: #909399;
            padding: 5px 0;
        }
        .el-tag {
            height: 20px;
            margin: 1px;
            line-height: 20px;
            border-radius: 2px;
            padding: 0 4px;
            /deep/.el-icon-close:hover {
                background-color: rgba(0, 0, 0, 0);
                color: #409eff;
            }
        }
    }
}
</style>
